import * as React from "react";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useParams,
  useRouteMatch,
} from "react-router";
import { useDispatch } from "react-redux";
import { cloneDeep } from "lodash";

//store, state
import usePermissionRedirect from "../../hooks/usePermissionRedirect";
import {
  updateActiveFormInstance,
  setActiveFormInstance,
  usePermissionCheck,
} from "../../store/base";
import {
  useRoundingErrandSetting,
  constants,
  overviewUrl,
} from "../../store/roundingErrandSettings";

//components & styles
import DeleteModal from "../../components/Forms/Delete/DeleteModal";
import { DetailLayoutWrapper } from "../../components/sharedStyles";
import DetailPageHeaderMenu from "../Layouts/DetailPageHeaderMenu/DetailPageHeaderMenu";
import RoundingOverview from "./settingdetail/Overview";
import RoundingErrand from "./settingdetail/Errands";

import SettingModalForm from "../../components/Forms/RoundingErrandSetting/ChapterForm/ModalForm";

import OverlaySpinner from "../../components/Loaders/OverlaySpinner";

function RoundingErrandSettingDetail() {
  const dispatch = useDispatch();
  const storeName = constants.STORE_NAME;
  const { settingId } = useParams();
  const { url, path } = useRouteMatch();
  const { replace } = useHistory();

  const [roundingErrandSetting, roundingErrandSettingLoading] =
    useRoundingErrandSetting(settingId);

  const [editErrandOpen, setEditErrandOpen] = React.useState(false);

  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);
  usePermissionRedirect(["view_can_roundingerrand", "allow_errand_roundings"]);

  const canEdit = usePermissionCheck("change_can_roundingerrand");
  const canDelete = usePermissionCheck("delete_can_roundingerrand");

  const SUB_PAGES = [
    {
      path: "/overview",
      label: "Översikt",
      component: RoundingOverview,
    },
    {
      path: "/errands",
      label: `Ärenden`,
      component: RoundingErrand,
    },
  ];

  const subPageLinks = SUB_PAGES.map((sp) => ({
    url: `${url}${sp.path}`,
    label: sp.label,
  }));

  const onEdit = () => {
    const errandClone = cloneDeep(roundingErrandSetting);
    dispatch(updateActiveFormInstance({ storeName, data: errandClone }));

    setEditErrandOpen(true);
  };

  const handleActions = [];

  if (canEdit) {
    handleActions.push({
      name: "Redigera",
      onClick: onEdit,
    });
  }

  if (canDelete) {
    handleActions.push({
      name: "Radera",
      onClick: () => setDeleteModalOpen(true),
      isDelete: true,
    });
  }

  React.useEffect(() => {
    return () => {
      dispatch(setActiveFormInstance({ storeName, data: {} }));
    };
  }, []);

  return (
    <>
      {roundingErrandSettingLoading && <OverlaySpinner />}
      <DeleteModal
        isOpen={deleteModalOpen}
        closeFunction={() => setDeleteModalOpen(false)}
        instance={roundingErrandSetting}
        constants={constants}
        deletedCallback={() => replace(overviewUrl({ govErrand: false }))}
      />

      {canEdit && (
        <SettingModalForm
          method="PATCH"
          id={roundingErrandSetting?.id}
          isOpen={editErrandOpen}
          onCheckout={() => setEditErrandOpen(false)}
        />
      )}

      <DetailLayoutWrapper>
        <DetailPageHeaderMenu
          title={`Ronderingstyp ${
            roundingErrandSetting?.str_representation || "laddar..."
          }`}
          breadCrumbs={[
            { url: "/rounding-errands", label: "Ronderingar" },
            { label: roundingErrandSetting?.str_representation || "Laddar..." },
          ]}
          {...{ subPages: subPageLinks, handleActions }}
        />

        <Switch>
          {SUB_PAGES.map((sp) => (
            <Route
              key={sp.path}
              path={`${path}${sp.path}`}
              component={sp.component}
            />
          ))}

          {/* Default sub page  */}
          <Redirect exact to={`${url}${SUB_PAGES[0].path}`} path={`${path}`} />
        </Switch>
      </DetailLayoutWrapper>
    </>
  );
}

export default RoundingErrandSettingDetail;
